export class SaveProductRecipeLinkingRequestInput {
  orderId?: number;
  shopifyOrderId?: number;
  userId?: number;
  linkingRequestItems: SaveProductRecipeLinkingRequestInputItem[];
  clientAreaRequisition: boolean;
  confirmLinkingRequests: boolean;
  processPrescriptionState?: boolean|null;
}

export class SaveProductRecipeLinkingRequestInputItem {
  customerRecipeId: number;
  frameSku: string;
  lensSku: string;
  orderItemIds: number[];
  pairNumber: number;
}